import { useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { Icon } from '../core/Icon';
import { Badge } from '../core/Badge';
import { propsDeAtivacao } from '../core/interativo';
import type { EventoDeAtivacao } from '../core/interativo';
import type { BadgeTone } from '../core/Badge';

export type DocumentoStatus = 'assinado' | 'aguardando' | 'rascunho' | 'cancelado' | 'rejeitado';

const statusTone: Record<DocumentoStatus, BadgeTone> = {
    assinado: 'success', aguardando: 'warning', rascunho: 'neutral', cancelado: 'danger', rejeitado: 'danger',
};

export interface DocumentCardProps {
    title?: string;
    patient?: ReactNode;
    updatedAt?: ReactNode;
    status?: DocumentoStatus;
    pages?: number;
    onClick?: (e: EventoDeAtivacao) => void;
    actions?: ReactNode;
    style?: CSSProperties;
}

export function DocumentCard({
    title, patient, updatedAt, status = 'rascunho', pages, onClick, actions, style,
}: DocumentCardProps) {
    const [hover, setHover] = useState(false);
    const interacao = propsDeAtivacao(onClick, title ? `Abrir documento ${title}` : 'Abrir documento');
    const rotulo = status.charAt(0).toUpperCase() + status.slice(1);

    return (
        <article
            {...interacao}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: 13, background: 'var(--surface)',
                border: `1px solid ${hover ? 'var(--border-strong)' : 'var(--border)'}`, borderRadius: 'var(--radius-md)',
                cursor: onClick ? 'pointer' : 'default', transition: 'var(--transition-control)', textAlign: 'left', ...style,
            }}
        >
            <span style={{ width: 34, height: 34, flex: '0 0 auto', borderRadius: 'var(--radius-sm)', background: 'var(--surface-secondary)', border: '1px solid var(--border-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--neutral-600)' }}>
                <Icon name="file-text" size={16} />
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: 13.5, fontWeight: 600, color: 'var(--text-primary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</p>
                <p style={{ margin: '2px 0 0', fontSize: 12.5, color: 'var(--text-secondary)' }}>
                    {patient}
                    {updatedAt && <> · {updatedAt}</>}
                    {pages && <> · {pages} pág.</>}
                </p>
            </div>
            <Badge tone={statusTone[status] ?? 'neutral'} dot>{rotulo}</Badge>
            {actions}
        </article>
    );
}
